// src/pages/QueuePlanner.js
import React, { useEffect, useState } from "react";
import { Button, Space, message, Spin } from "antd";
import { Link } from "react-router-dom";
import DayBar from "../components/DayBar";
import ProductModal from "../components/ProductModal";
import QueueFlow from "../components/QueueFlow";
import {
  fetchQueue,
  createQueueItem,
  reorderQueue,
  updateQueueItem,
  deleteQueueItem,
} from "../api/queueApi";

function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export default function QueuePlanner() {
  const [day, setDay] = useState(todayISO());
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await fetchQueue(day);
      setItems(data.items || []);
    } catch (e) {
      message.error(e.message || "Erro ao buscar fila");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [day]);

  const handleCreate = async (values) => {
    const payload = {
      day,
      status: "READY",
      ...values, // <<< ISSO RESOLVE TUDO
    };
  
    console.log("POST payload (FINAL):", payload);
  
    const { item } = await createQueueItem(payload);
    setItems((prev) => [...prev, item]);
    setOpen(false);
  };
  
  

  const handleUpdate = async (values) => {
    try {
      const payload = {
        ...values, // ✅ inclui imageUrl/imagePath quando existir
        priceFrom: values.priceFrom ?? null,
        priceTo: values.priceTo ?? null,
      };
  
      console.log("PUT payload:", payload);
  
      const { item } = await updateQueueItem(editing.id, payload);
  
      setItems((prev) => prev.map((p) => (p.id === editing.id ? item : p)));
      message.success("Atualizado ✅");
      setOpen(false);
    } catch (e) {
      message.error(e.message || "Erro ao atualizar");
    }
  };
  

  const handleDelete = async (item) => {
    try {
      await deleteQueueItem(item.id);
      setItems((prev) => prev.filter((p) => p.id !== item.id));
      message.success("Deletado ✅");
    } catch (e) {
      message.error(e.message || "Erro ao deletar");
    }
  };

  const onSaveOrder = async (orderedIds, positions) => {
    const { items: updated } = await reorderQueue(day, orderedIds, positions);
    setItems(updated || []);
  };

  // futuramente: esconder enviados
  // const visibleItems = items.filter(i => i.status !== "SENT");
  const visibleItems = items;

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: 18,
        background: "linear-gradient(180deg, #0b0b0c, #060607)",
        color: "white",
      }}
    >
      <Space style={{ width: "100%", justifyContent: "space-between" }}>
        <Space wrap>
          <DayBar day={day} onChange={setDay} />

          <Link to="/fila">
            <Button ghost>Ver como lista</Button>
          </Link>
        </Space>

        <Button
          type="primary"
          onClick={() => {
            setEditing(null);
            setOpen(true);
          }}
        >
          + Produto
        </Button>
      </Space>

      <div style={{ marginTop: 14 }}>
        {loading ? (
          <div style={{ padding: 30 }}>
            <Spin />
          </div>
        ) : (
          <QueueFlow
            day={day}
            items={visibleItems}
            onEdit={(item) => {
              setEditing(item);
              setOpen(true);
            }}
            onDelete={handleDelete}
            onSaveOrder={onSaveOrder}
          />
        )}
      </div>

      <ProductModal
        open={open}
        editing={editing}
        onCancel={() => setOpen(false)}
        onCreate={handleCreate}
        onUpdate={handleUpdate}
      />
    </div>
  );
}
